import { MenuItem, TextField } from '@mui/material';
import { Styles } from 'common/types';
import { SelectOption } from 'common/ui/select-field/select-field';
import { ADDED_FOUNDED_FILTER } from 'modules/settings/constants';
import { ChangeEvent, ReactElement } from 'react';

const options: Array<SelectOption> = [
  {
    title: 'ALL',
    value: ADDED_FOUNDED_FILTER.ALL,
  },
  {
    title: 'New',
    value: ADDED_FOUNDED_FILTER.NEW,
  },
  {
    title: 'Existing',
    value: ADDED_FOUNDED_FILTER.EXISTING,
  },
];

const styles: Styles = {
  select: { marginLeft: 2, width: 150, ':first-child': { marginLeft: 0 } },
};

interface Props {
  onChange: (value: number) => void;
  value: number;
}

export function AddedFoundedSelect({ onChange, value }: Props): ReactElement {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(parseInt(e.target.value, 10));
  };

  return (
    <TextField
      select
      color="primary"
      sx={styles.select}
      onChange={handleChange}
      value={value}
      size="small"
      label="Added/Founded"
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.title}
        </MenuItem>
      ))}
    </TextField>
  );
}
